import React from 'react';

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: false
        }
    }

    componentDidMount() {
        this.setState({
            loggedIn: this.props.loggedIn
        })
    }

    render() {
        return (
            <div>
                <nav className={'navbar navbar-custom'}>
                    <div className={'container-fluid'}>
                        <div className='navbar-header'>
                            <a className={'navbar-brand navbar-brand-align'} href='#'>RM-AGILE</a>
                        </div>
                        <ul className={'nav navbar-nav navbar-right'}>
                            {/* <li className={'nav-align'}><span className={'glyphicon glyphicon-search search-align'}></span><input placeholder={'Search'}/></li> */}
                            {this.state.loggedIn && (
                              <li className='nav-align' style={{color: 'white', marginTop: 17, marginRight: 20, cursor: 'pointer'}} onClick={this.props.onLogout}>Logout</li>
                            )}
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js